import { useEffect, useState } from 'react';

import { IAreas, IMap } from './models';

const getShapeCenter = (
  shape: string,
  coords: string,
  width: number,
  height: number
): [number, number] => {
  const coordsArray = coords.split(',').map(Number);
  let x = 0;
  let y = 0;

  switch (shape) {
    case 'circle':
      x = (coordsArray[0] / width) * 100;
      y = (coordsArray[1] / height) * 100;
      break;
    case 'rect':
      x = ((coordsArray[0] + coordsArray[2]) / 2 / width) * 100;
      y = ((coordsArray[1] + coordsArray[3]) / 2 / height) * 100;
      break;
    case 'poly': {
      const xs = coordsArray.filter((_, i) => i % 2 === 0);
      const ys = coordsArray.filter((_, i) => i % 2 === 1);
      const avgX = (Math.min(...xs) + Math.max(...xs)) / 2;
      const avgY = (Math.min(...ys) + Math.max(...ys)) / 2;
      x = (avgX / width) * 100;
      y = (avgY / height) * 100;
      break;
    }
    default:
      break;
  }

  return [x, y];
};

const useMapResize = (
  map: IMap[],
  width: number,
  height: number,
  imageWidth: number
): {
  areas: IAreas[];
} => {
  const [areas, setAreas] = useState<IAreas[]>([]);

  useEffect(() => {
    if (!map || !width || !height) return;

    const percentage = imageWidth && imageWidth !== width ? imageWidth / width : 1;

    const updatedAreas = map.map((area) => {
      const scaledCoords = area.coords
        .split(',')
        .map((n) => Math.round(Number(n) * percentage))
        .join(',');

      const center = getShapeCenter(
        area.shape,
        scaledCoords,
        imageWidth,
        (imageWidth / width) * height
      );

      return {
        ...area,
        coords: scaledCoords,
        center,
      };
    });

    setAreas(updatedAreas);
  }, [map, width, height, imageWidth]);

  return { areas };
};

export default useMapResize;
